import React from 'react';
import { StarIcon } from 'lucide-react';

// Paste the existing Veterans For Life logo URL here (white version for dark backgrounds).
const LOGO_SRC = '';
type LogoProps = {
  compact?: boolean;
};
export function Logo({
  compact = false
}: LogoProps) {
  if (LOGO_SRC) {
    return <img src={LOGO_SRC} alt="Veterans For Life — Vets helping vets since 2024" className={`w-auto transition-[height] duration-200 ease-out ${compact ? 'h-10' : 'h-14'}`} data-id="element-75" data-mp="3v8eews8fivn2" />;
  }
  return <span className="flex items-center gap-3 text-paper" data-id="element-76" data-mp="rqw9erg4q0pt">
      <StarIcon aria-hidden="true" className="h-6 w-6 fill-paper text-paper" strokeWidth={1} data-id="element-77" data-mp="ds6cbbtb811g" />
      <span className="flex flex-col leading-none" data-id="element-78" data-mp="duip7ak7nl7n">
        <span className="font-sans text-base font-bold tracking-[0.22em] sm:text-lg" data-id="element-79" data-mp="hsgh4l5d8leq">VETERANS FOR LIFE</span>
        <span className={`overflow-hidden text-[11px] font-medium tracking-[0.18em] text-paper/75 transition-[max-height,margin,opacity] duration-200 ease-out ${compact ? 'mt-0 max-h-0 opacity-0' : 'mt-1.5 max-h-4 opacity-100'}`} data-id="element-80" data-mp="2ygu1ofc92xsw">
          VETS HELPING VETS SINCE 2024
        </span>
      </span>
    </span>;
}